export function linkify(text: string): string {
  if (!text) return ""; // Handle null or undefined input
  return text.replace(
    /(^|[^"'>])(\bhttps?:\/\/[^\s<]+)/gi,
    (match, prefix, url) => {
      return `${prefix}<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    }
  );
}

export function sanitizeHtml(html: string): string {
  if (!html) return ""; // Handle null or undefined input
  const scriptTagPattern =
    /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
  html = html.replace(scriptTagPattern, "");

  const dangerousAttributesPattern = / on\w+="[^"]*"/gi;
  html = html.replace(dangerousAttributesPattern, "");

  const dangerousTagsPattern =
    /<\/?(iframe|object|embed|link|style|meta|form|input|button|textarea|select|option|applet|base|basefont|bgsound|blink|body|frame|frameset|head|html|ilayer|layer|link|marquee|noframes|noscript|param|plaintext|script|title|xml|xss)[^>]*>/gi;
  html = html.replace(dangerousTagsPattern, "");

  return html;
}


export function trimTo250(str: string): string {
  return str.length > 250 ? str.slice(0, 250) + "..." : str;
}


export const sanitizeFileName = (name: string): string => {
  // allow alphanumeric, dot, dash, underscore
  return name.replace(/[^a-zA-Z0-9._-]/g, "_");
};

export const isSafeUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return (
      parsed.protocol === "https:" &&
      parsed.hostname.endsWith(".blob.core.windows.net")
    );
  } catch {
    return false;
  }
};